import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import * as InvoiceSessionNumberActions from './invoice-session-number.actions';
import { InvoiceSessionNumber } from './invoice-session-number.model';

export const invoiceSessionNumbersFeatureKey = 'invoiceSessionNumbers';

export interface State extends EntityState<InvoiceSessionNumber> {
    // additional entities state properties
}

export const adapter: EntityAdapter<InvoiceSessionNumber> =
    createEntityAdapter<InvoiceSessionNumber>();

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});

const invoiceSessionNumberReducer = createReducer(
    initialState,
    on(InvoiceSessionNumberActions.addInvoiceSessionNumber, (state, action) =>
        adapter.addOne(action.invoiceSessionNumber, state)
    ),
    on(
        InvoiceSessionNumberActions.upsertInvoiceSessionNumber,
        (state, action) => adapter.upsertOne(action.invoiceSessionNumber, state)
    ),
    on(InvoiceSessionNumberActions.addInvoiceSessionNumbers, (state, action) =>
        adapter.addMany(action.invoiceSessionNumbers, state)
    ),
    on(
        InvoiceSessionNumberActions.upsertInvoiceSessionNumbers,
        (state, action) =>
            adapter.upsertMany(action.invoiceSessionNumbers, state)
    ),
    on(
        InvoiceSessionNumberActions.updateInvoiceSessionNumber,
        (state, action) => adapter.updateOne(action.invoiceSessionNumber, state)
    ),
    on(
        InvoiceSessionNumberActions.updateInvoiceSessionNumbers,
        (state, action) =>
            adapter.updateMany(action.invoiceSessionNumbers, state)
    ),
    on(
        InvoiceSessionNumberActions.deleteInvoiceSessionNumber,
        (state, action) => adapter.removeOne(action.id, state)
    ),
    on(
        InvoiceSessionNumberActions.deleteInvoiceSessionNumbers,
        (state, action) => adapter.removeMany(action.ids, state)
    ),
    on(InvoiceSessionNumberActions.loadInvoiceSessionNumbers, (state, action) =>
        adapter.setAll(action.invoiceSessionNumbers, state)
    ),
    on(InvoiceSessionNumberActions.clearInvoiceSessionNumbers, state =>
        adapter.removeAll(state)
    )
);

export function reducer(state: State | undefined, action: Action) {
    return invoiceSessionNumberReducer(state, action);
}
